
import { useEffect, useRef } from 'react';
import './css/AnimatedTitleComponent.css';

interface AnimatedTitleComponentProps {
    holdDuration?: number; // in milliseconds
}
    export const AnimatedTitleComponent: React.FC<AnimatedTitleComponentProps> = ({ holdDuration = 500 }) => {

    const slotWordRef = useRef<HTMLDivElement | null>(null);
    // Tap-and-hold (long press)
    let pressTimer: number | null = null;

    function slotWordActivateHandler() {
        if (slotWordRef.current) {
            slotWordRef.current.classList.remove('slot-word');
            // Force reflow to restart animation
            void slotWordRef.current.offsetWidth;
            slotWordRef.current.classList.add('slot-word');        
        }
    }

    useEffect(() => {
        if (slotWordRef.current) {
            slotWordRef.current.addEventListener("dblclick", slotWordActivateHandler);
            slotWordRef.current?.addEventListener('touchstart', () => {
                pressTimer = window.setTimeout(slotWordActivateHandler, holdDuration); // 500ms hold
            });

            slotWordRef.current?.addEventListener('touchend', () => {
                if (pressTimer) {
                    clearTimeout(pressTimer);
                    pressTimer = null;
                }
            });
        }
        return () => {
            if (slotWordRef.current) {
                slotWordRef.current.removeEventListener("dblclick", slotWordActivateHandler);
            }
        }
    }, []);

    return (
        <div className="slot-word-container">
            <div className="slot-word" ref={slotWordRef}>
                <span className="slot">S</span>
                <span className="slot">k</span>
                <span className="slot">i</span>
                <span className="slot">t</span>
                <span className="slot">t</span>
                <span className="slot">e</span>
                <span className="slot">r</span>
                <span className="slot">b</span>
                <span className="slot">o</span>
                <span className="slot">o</span>
                <span className="slot">k</span>
            </div>
        </div>
    );
};
